<template>
    <div>
        <el-upload
            class="upload-demo"
            action="/media/v1/upload"
            multiple
            :disabled="disabled"
            v-bind="$attrs"
            :show-file-list="false"
            :before-upload="uploadBefore"
            :on-success="uploadSuccess"
        >   
            
            <div class=""><el-button size="small" type="primary" icon="el-icon-plus" :loading="avatarUploadStatus">点击上传图片</el-button></div>
            
        </el-upload>
    </div>
</template>
<script>
export default {
    name:'OnlyUpload',
    props:{
        limit:{
            type:Number,
            default:0
        },
        disabled:{
            type:Boolean,
            default:true,
        }
    },
    data(){
        return {
            avatarUploadStatus:false,
            
        }
    },
    methods:{
        //头像上传
        uploadBefore(){
            this.avatarUploadStatus = true;
        },
        uploadSuccess(response){
            this.avatarUploadStatus = false;
            this.$emit('success',response.data.list[0].path);    
        },
    }
}
</script>
<style lang="scss" scoped>
.upload-demo{
    position: relative;
    
}
</style>